import {
  getClaimShareThread,
  offerTransactionThread,
} from "_graphql/visal/mutations/publish-offer";
import { useQuery } from "@apollo/client";
import {
  GetClaimShareThread,
  GetClaimShareThreadVariables,
} from "_graphql/visal/mutations/__generated__/GetClaimShareThread";
import {
  OfferTransactionThread,
  OfferTransactionThreadVariables,
} from "_graphql/visal/mutations/__generated__/OfferTransactionThread";

export const useParticipationThread = (
  variables?: OfferTransactionThreadVariables
) => {
  const { data, ...rest } = useQuery<
    OfferTransactionThread,
    OfferTransactionThreadVariables
  >(offerTransactionThread, {
    variables: variables,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });

  return {
    thread: data?.offerTransactionThread || [],
    ...rest,
  };
};

export const useClaimParticipationThread = (
  variables?: GetClaimShareThreadVariables
) => {
  const { data, ...rest } = useQuery<
    GetClaimShareThread,
    GetClaimShareThreadVariables
  >(getClaimShareThread, {
    variables: variables,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });

  return {
    thread: data?.getClaimShareThread || [],
    ...rest,
  };
};
